/**
 * ParLinx reviews ticker — takes over from the pure-CSS marquee and drives a
 * real scroll container: auto-advance via rAF, grab-to-scrub on desktop,
 * native swipe on touch, pause while interacting, resume after idle.
 * Duplicated track halves make the wrap seamless. Classic IIFE: the
 * storefront ships no ES modules.
 */
(function () {
  'use strict';

  var ticker = document.querySelector('[data-plx-ticker]');
  if (!ticker) return;
  var track = ticker.querySelector('.plx-ticker__track');
  if (!track) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  ticker.classList.add('is-js');

  var half = 0;
  function measure() {
    half = track.scrollWidth / 2;
  }
  measure();
  window.addEventListener('resize', measure);

  var SPEED = 0.6; /* px per frame ≈ 36px/s at 60fps */
  var RESUME_MS = 2500;
  var paused = false;
  var hovering = false;
  var dragging = false;
  var idleTimer = null;
  var lastX = 0;

  function wrap() {
    if (half <= 0) return;
    if (ticker.scrollLeft >= half) ticker.scrollLeft -= half;
    else if (ticker.scrollLeft <= 0 && dragging) ticker.scrollLeft += half;
  }

  function restAfter(ms) {
    paused = true;
    clearTimeout(idleTimer);
    idleTimer = setTimeout(function () {
      if (!hovering && !dragging) paused = false;
    }, ms);
  }

  function tick() {
    if (!paused && !reduced) {
      ticker.scrollLeft += SPEED;
      wrap();
    }
    requestAnimationFrame(tick);
  }

  ticker.addEventListener('mouseenter', function () {
    hovering = true;
    paused = true;
  });
  ticker.addEventListener('mouseleave', function () {
    hovering = false;
    if (!dragging) restAfter(600);
  });

  /* native touch / trackpad scrolling */
  ticker.addEventListener('touchstart', function () { restAfter(RESUME_MS); }, { passive: true });
  ticker.addEventListener('wheel', function () { restAfter(RESUME_MS); }, { passive: true });
  ticker.addEventListener('scroll', function () { if (paused) wrap(); }, { passive: true });

  /* desktop click-drag scrub */
  /* cards are <a>s: a real mouse drag starts a native link drag, which
     fires dragstart and CANCELS the pointer stream, killing the scrub —
     block it (synthetic-event tests pass without this; real mice don't) */
  ticker.addEventListener('dragstart', function (e) { e.preventDefault(); });
  var dragTravel = 0;
  ticker.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse') return;
    dragging = true;
    dragTravel = 0;
    lastX = e.clientX;
    paused = true;
    ticker.setPointerCapture(e.pointerId);
    ticker.classList.add('is-grabbing');
  });
  ticker.addEventListener('pointermove', function (e) {
    if (!dragging) return;
    dragTravel += Math.abs(e.clientX - lastX);
    ticker.scrollLeft -= e.clientX - lastX;
    lastX = e.clientX;
    wrap();
  });
  /* cards are links: a click that ends a scrub is a scrub, not a click */
  ticker.addEventListener('click', function (e) {
    if (dragTravel > 5) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
  function release() {
    if (!dragging) return;
    dragging = false;
    ticker.classList.remove('is-grabbing');
    restAfter(RESUME_MS);
  }
  ticker.addEventListener('pointerup', release);
  ticker.addEventListener('pointercancel', release);

  requestAnimationFrame(tick);
})();
